import React from "react";
import "./index.scss";

const classPrefix = "yfm-product-detail-info-skeleton";

const ProductInfoSkeleton: React.FC = () => {
  return (
    <div className={`${classPrefix}`}>
      <div className={`${classPrefix}__product-name-box yfm-is-skeleton`}>
        <span>Earn above public commissions by downloading YooFinds!</span>
      </div>
      <div className={`${classPrefix}__type-box`}>
        <div className={`${classPrefix}__type-btn yfm-is-skeleton`}>
          Bodysuits
        </div>
        <div className={`${classPrefix}__type-btn yfm-is-skeleton`}>SKU</div>
      </div>
      <div className={`${classPrefix}__product-info-box yfm-is-skeleton`}></div>
    </div>
  );
};

export default ProductInfoSkeleton;
